"use client";

import { MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import DestinationQuiz from "./DestinationQuiz";
import { Title, Text } from "@/components/ui/Headings";

export default function InspirationSection() {
  const { t } = useTranslation();
  const [showQuiz, setShowQuiz] = useState(false);

  if (showQuiz) {
    return (
      <section className="py-8 bg-gradient-to-br from-purple-50 to-lime-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <DestinationQuiz />
        </div>
      </section>
    );
  }

  return (
    <section className="py-8 bg-gradient-to-br from-purple-50 to-lime-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center flex flex-col items-center gap-6">
        <div className="flex flex-col items-center gap-2 w-full">
          <MapPin size={48} className="text-purple-400 mx-auto" />
          <Title size="lg" className="font-bold text-gray-900">
            {t("destinations.inspiration.title")}
          </Title>

          <Text variant="body" className="text-gray-600 max-w-2xl mx-auto">
            {t("destinations.inspiration.subtitle")}
          </Text>
        </div>

        <button
          onClick={() => setShowQuiz(true)}
          className="inline-flex items-center text-white px-6 lg:px-8 py-2.5 lg:py-3 rounded-full text-sm lg:text-base font-bold hover:shadow-xl transition-all duration-300 group shadow-lg bg-primary-600 hover:bg-primary-550"
        >
          {t("destinations.inspiration.cta")}
        </button>
      </div>
    </section>
  );
}
